export default "__VITE_ASSET__CZ2TkuJw__"